import { render, staticRenderFns } from "./CheckboxSvg.vue?vue&type=template&id=467627fe&scoped=true&"
import script from "./CheckboxSvg.vue?vue&type=script&lang=js&"
export * from "./CheckboxSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467627fe",
  null
  
)

export default component.exports